import { takeLatest, call, put } from "redux-saga/effects";

import axios from 'axios';

import API_ENDPOINTS from "@services/apiConfig";


export const actionTypes = {
    fetchPaymentStatus: 'PARTNER/FETCH_PAYMENT_STATUS_INITIATED',
    fetchPaymentStatusSuccess: 'PARTNER/FETCH_PAYMENT_STATUS_SUCCESS',
    fetchPaymentStatusFailed: 'PARTNER/FETCH_PAYMENT_STATUS_FAILED',
};

export const actions = {
    fetchPaymentStatus: (params) => ({ 
        type: actionTypes.fetchPaymentStatus,
        payload: params
    }),
    fetchPaymentStatusSuccess: () => ({
        type: actionTypes.fetchPaymentStatusSuccess
    }),
    fetchPaymentStatusFailed: () => ({
        type: actionTypes.fetchPaymentStatusFailed
    })
};

const initialState = {
    fetching: false,
    fetched: false,
    data: {},
    errMsg: null,
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.fetchPaymentStatus: {
            return {
                ...state,
                fetching: true,
            }
        }
        case actionTypes.fetchPaymentStatusSuccess: {
            return {
                ...state,
                fetched: true,
                data: action.payload,
            }
        }
         case actionTypes.fetchPaymentStatusFailed: {
            return {
                ...state,
                fetched: true,
                errMsg: action.payload,
            }
        }
        default:
            return state;
    }
};

export const selectors = {
    getStatus: (state) =>  state.partnerApp.paymentStatus.data.status || '',
    getRedirectUrl: (state) => state.partnerApp.paymentStatus.data.redirectUrl || '',
};


function* fetchPaymentStatusWorker(action) {
    const { payload } = action;
    try {
      const response = yield call(
        [axios, 'post'],
        API_ENDPOINTS.SHOPIFY.PAYMENT_STATUS,
        (payload)
      )
      yield put({ type: actionTypes.fetchPaymentStatusSuccess, payload: response.data });
    } catch (err) {
      const errResponse = yield err.response;
    }
  }

export function* saga() {
    yield takeLatest(actionTypes.fetchPaymentStatus, fetchPaymentStatusWorker);
}